import { api } from 'webReservations/api';
import { ReservationStatus } from '@shared/types/reservations';

export interface Restaurant {
  id: string;
  name: string;
  description: string;
  address: string;
  phone: string;
  website: string;
  locationSlug: string;
  nameSlug: string;
  timezone: string;
}

export interface Reservation {
  buyNowPrice: number | null;
  date: string;
  floorPlanSnapshotHash: string | null;
  guestCount: number;
  id: string;
  restaurant: Restaurant;
  restaurantEvent: {
    id: string;
    name: string;
  } | null;
  status?: ReservationStatus;
  listing: {
    publicName: string;
  } | null;
  time: string;
  wasTableChosenAtTimeOfBooking: boolean;
}

export const clearListPrice = async (reservationId: string): Promise<void> =>
  api.post(`/reservations/${reservationId}/clear-buy-now`);

export const getConfirmedReservations = async (): Promise<Reservation[]> =>
  api.get(`/reservations/confirmed`);

export const getInactiveReservations = async (): Promise<Reservation[]> =>
  api.get('/reservations/inactive');

export const updateListPrice = async (
  reservationId: string,
  price: number,
): Promise<void> =>
  api.post(`/reservations/${reservationId}/set-buy-now`, { price });

export const updateReservationNote = async (
  reservationId: string,
  note: string | null,
) => api.post(`/reservations/${reservationId}/update-note`, { note });
